import httpRequest from 'httpRequest'
import { GLCodeContract } from 'models'

const GLCODE_PREFIX = '/company/glcodes'

const glCodeService = {
    getGLCodes: () => httpRequest.get<GLCodeContract[]>(`${GLCODE_PREFIX}`),
    getGLCode: (accountId: string) =>
        httpRequest.get<GLCodeContract>(`${GLCODE_PREFIX}/${accountId}`),
    updateStatusGLCode: (path: 'active' | 'inactive', glCodesId: string) =>
        httpRequest.put(`${GLCODE_PREFIX}/glCodeId/${path}`),
    updateGLCode: (glCodeId: string, payload: GLCodeContract) =>
        httpRequest.put(`${GLCODE_PREFIX}/${glCodeId}`, payload),
    deleteGLCodes: (glCodeIds: string[], isForceDelete: boolean = false) =>
        httpRequest.delete(`${GLCODE_PREFIX}`, {
            params: { glCodeIds, isForceDelete },
        }),
    createGLCode: (payload: GLCodeContract) =>
        httpRequest.post(`${GLCODE_PREFIX}`, payload),
    validationGLCodeInUsed: (glCodeIds: string[]) =>
        httpRequest.get(`${GLCODE_PREFIX}/validate-glcode-in-used`, {
            params: { glCodeIds: glCodeIds },
        }),
    importGLCode: (formData: FormData) =>
        httpRequest.post(`${GLCODE_PREFIX}/import`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        }),
}

export default glCodeService
